import React, { Fragment } from "react";
import { Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import StarIcon from "@mui/icons-material/Star";
import Marquee from "react-fast-marquee";
import { styled } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.contrastText,
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  promotionText: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  lastPromotionText: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(30),
  },
  testimonialText: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  lastTestimonialText: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(30),
  },
  testimonialContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
}));

const StyledStarIcon = styled(StarIcon, {
  shouldForwardProp: (props) => props !== "ratingColor",
})(({ ratingColor }) => ({
  color: ratingColor,
}));

export default function TopBanner({ bannerData }) {
  const classes = useStyles();
  const currentTime = Date.now();
  const dataPriorityContent = [
    { promotionText: bannerData.promotionText },
    { testimonial_text: bannerData.testimonial_text },
  ];
  const typographyStyle = {
    fontSize: `${bannerData.font_size}rem`,
    lineHeight: `${bannerData.font_size}rem`,
    paddingTop: `${bannerData.font_size / 2 - 0.1}rem`,
  };

  if (bannerData.promotion_priority < bannerData.testimonial_priority) {
    dataPriorityContent.reverse();
  }

  const showFirst = React.useMemo(() => {
    return dataPriorityContent.map((content, i) => {
      if (content.hasOwnProperty("promotionText")) {
        return (
          <Fragment key={i.toString()}>
            {content.promotionText.map((promoText, i) => {
              const className =
                i === content.promotionText.length - 1
                  ? classes.lastPromotionText
                  : classes.promotionText;
              return (
                <Typography
                  key={i.toString()}
                  variant="h6"
                  className={className}
                  sx={typographyStyle}
                >
                  {promoText}
                </Typography>
              );
            })}
          </Fragment>
        );
      } else {
        return (
          <Fragment key={i.toString()}>
            {content.testimonial_text.map((testimonialText, i) => {
              const className =
                i === content.testimonial_text.length - 1
                  ? classes.lastTestimonialText
                  : classes.testimonialText;
              return (
                <Fragment key={testimonialText}>
                  <Box mx={1} className={classes.testimonialContainer}>
                    {Array(bannerData?.testimonial_rating || 5)
                      .fill(0)
                      .map((_, i) => (
                        <StyledStarIcon
                          key={testimonialText + i}
                          ratingColor={bannerData.rating_color}
                          fontSize={bannerData.font_size > 1.0 ? "large" : "small"}
                        />
                      ))}
                    {
                      <Typography variant="h6" className={className} sx={typographyStyle}>
                        {testimonialText}
                      </Typography>
                    }
                  </Box>
                </Fragment>
              );
            })}
          </Fragment>
        );
      }
    });
  }, []);

  if (new Date(bannerData.deadline).getTime() < currentTime) {
    return null;
  }

  return (
    <div className={`${classes.root} show`}>
      <Marquee speed={bannerData?.speed || 50} pauseOnHover gradient={false}>
        {showFirst}
      </Marquee>
    </div>
  );
}
